function updateMainProductImage(imageUrl, mainImageElement) {
  if (!imageUrl || imageUrl.includes("error")) {
    return;
  }
  mainImageElement.src = imageUrl;
  mainImageElement.srcset = imageUrl;
  mainImageElement.setAttribute("data-photoswipe-src", imageUrl);
}
function checkForDropdownBundleErrors() {
  const selectors = document.querySelectorAll(".bundle-product-selector");
  const bundleForm = document.getElementById("bundle-selection-form");
  const bundleData = JSON.parse(bundleForm.dataset.bundle);

  const requiredProducts = [];
  for (let ind = 1; ind <= 7; ind++) {
    const isReq = bundleData[`product_list_${ind}_required`];
    if (!isReq) {
      continue;
    }
    requiredProducts.push({
      name: `product_list_${ind}`,
      label: bundleData[`product_list_${ind}_label`],
    });
  }
  let showError = false;
  selectors.forEach((selector) => {
    const productIndex = requiredProducts.findIndex(
      (product) => product.name === selector.name
    );
    if ((productIndex >= 0 && !selector.selectedOptions[0]?.value) || selector.selectedOptions[0]?.disabled) {
      showError = true;
    } else if (productIndex >= 0) {
      requiredProducts.splice(productIndex, 1);
    }
  });
  const errorWrapHtml = document.querySelector(".dropdown-bundle-error");
  if (!showError) {
    errorWrapHtml.classList.toggle("hidden", true);
    return true;
  }
  const textErrorElement = errorWrapHtml.querySelector(".products-labels");
  textErrorElement.textContent = requiredProducts.map(
    (product) => `, ${product.label}`
  );
  errorWrapHtml.classList.remove("hidden");
  return false;
}

function getDataForBundle(bundleForm) {
  const bundleFormData = new FormData(bundleForm);
  const bundleData = JSON.parse(bundleForm.dataset.bundle);

  const bundleProductId = bundleForm.dataset.bundleProductVariantId;
  let stringOfIds = `${bundleProductId}:${bundleForm.dataset.mainProductId}`;
  const bundleItems = [{
    id: bundleForm.dataset.mainProductId,
    quantity: 1,
    properties:{}
  }];
  for (const [key, value] of bundleFormData.entries()) {
    if (!value) {
      continue;
    }
    const isReq = bundleData[`${key}_required`];
    if(isReq){
      bundleItems.push({
        id: value,
        quantity: 1,
        properties: {
          _bundleId: "",
        },
      });
      stringOfIds += ":" + value;
    }else{
      bundleItems.push({
        id: value,
        quantity: 1
      });
    }
  }
  return bundleItems.map((cartItem) => {
    if(cartItem?.properties){
      return {
        ...cartItem,
        properties: {
          _bundleId: stringOfIds,
        }
      }
    }else{
      return cartItem;
    }
  });
}
